import script from "./TasksTree.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksTree.vue?vue&type=script&setup=true&lang=js"

import "./TasksTree.vue?vue&type=style&index=0&id=3a0ece23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0ece23"]])

export default __exports__